import { FieldValues, UseFormResetField } from "react-hook-form";
import { Checkbox } from "../Checkbox";
import { checkboxClassName } from "../../../styles/input";
import FormInput, { FormInputProps } from "./FormInput";
import { useEffect, useState } from "react";
import { noop } from "lodash";

type ToggleableFormInputProps<TFieldValues extends FieldValues> =
  FormInputProps<TFieldValues> & {
    toggleText: string;
    initialVisible?: boolean;
    resetField: UseFormResetField<TFieldValues>;
    onCheckedChange?: (checked: boolean) => void;
  };

const ToggleableFormInput = <TFieldValues extends FieldValues>({
  toggleText,
  resetField,
  initialVisible = true,
  onCheckedChange: onCheckedChangeProps = noop,
  ...formInputProps
}: ToggleableFormInputProps<TFieldValues>) => {
  const { name } = formInputProps;
  const toggleId = `toggle-field-${name}`;
  const [isVisible, setIsVisible] = useState(initialVisible);

  useEffect(() => {
    setIsVisible(initialVisible);
  }, [initialVisible]);

  const onCheckedChange = (checked: boolean) => {
    if (checked) {
      resetField(name);
    }
    setIsVisible((prev) => !prev);
    onCheckedChangeProps(checked);
  };

  return (
    <>
      {isVisible && <FormInput {...formInputProps} />}
      <div className="flex items-center gap-2">
        <Checkbox
          className={checkboxClassName}
          id={toggleId}
          checked={!isVisible}
          onCheckedChange={onCheckedChange}
        />
        <label className="text-sm text-gray-500" htmlFor={toggleId}>
          {toggleText}
        </label>
      </div>
    </>
  );
};

export default ToggleableFormInput;
